import { useRouteError } from 'react-router';

import { ErrorScreen } from './ErrorScreen';

export const ErrorFallback = () => {
  const error = useRouteError();

  console.error('Route error:', error);

  const handleTryAgain = () => {
    window.location.reload();
  };

  const handleReturnToDashboard = () => {
    window.location.href = '/';
  };

  return <ErrorScreen onTryAgain={handleTryAgain} onReturnToDashboard={handleReturnToDashboard} />;
};
